module.exports = __webpack_public_path__ + "img/SME500_2021_Trademark_Authorised_02.279af9d9.png";